module.exports = {
  background: '#FFFFFF',
  backgroundDark: '#F3F1ED',

  primary: '#582474',
  primaryLight: '#ae66df',
  primaryDark: '#0A436C',

  secondary: '#DC536B',
  secondaryLight: '#D89BA6',
  secondaryDark: '#c60055',
};
